export default status => {
  if (status) {
    return '#ececff';
  } if (!status) {
    return '#e2e2e2';
  }
  return null;
};
